import React, { useEffect, useCallback } from 'react';
import List from '@mui/material/List';
import {
    Box,
    FormControl,
    InputAdornment,
    InputLabel,
    MenuItem,
    Select,
    TextField,
    Typography,
} from '@mui/material';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import Checkbox from '@mui/material/Checkbox';
import Chip from '@mui/material/Chip';
import { Downgraded, useState } from '@hookstate/core';
import SearchIcon from '@mui/icons-material/Search';
import ParticipantPopUpWindowDataList from './participantPopUpWindowDataList';

const listStyle = {
    width: '100%',
    height: '50vh',
    overflowY: 'auto',
    '&::-webkit-scrollbar': {
        width: '5px',
        height: '5px',
        backgroundColor: '#f1f1f1',
    },
    '&::-webkit-scrollbar-thumb': {
        background: '#c1c1c1',
    }
}
const ParticipantUserCheckList = (props) => {
    const [selected, setselected] = React.useState([]);
    const [search, setSearch] = React.useState('');
    const [allCheck, setAllCheck] = React.useState(false);

    useEffect(() => {
        if (props.selectedUsers) {
            if (allCheck === false) {
                setselected(props.selectedUsers)
            }
        }
    }, [props.selectedUsers, allCheck])

    useEffect(() => {
        if (props.resetCheckBox) {
            setselected([])
            setAllCheck(false)
            props.setResetCheckBox(false)
        }
    }, [props.resetCheckBox])
    const onCheckSelect = (userId, index) => {
        selected.includes(userId)
    }
    const handleToggle = useCallback((value) => {
        const newSelected = selected;
        const currentIndex = newSelected.indexOf(value.userID);
        if (currentIndex === -1) {
            newSelected.push(value.userID);
            if (newSelected) {
                props.checkUsers(newSelected);
                if (allCheck === false) {
                    props.onAddParticipant()
                }
            }

        } else {
            newSelected.splice(currentIndex, 1);
        }

        if (newSelected) {
            props.checkUsers(newSelected);
        }
        setselected(newSelected);
    }, [props.checkUsers, selected]);

    const setSearchValue = (value) => {
        setSearch(value);
        props.setSearch(value);

        if (value.trim().length > 0) {
            const newUserData = props.data.filter(
                (x) =>
                    x.name.toLowerCase().includes(value.toLowerCase()) ||
                    (x.userTags !== null && x.userTags.toLowerCase().includes(value.toLowerCase()))
            );
            props.setInviteParticipants(newUserData);
        }
    }

    const handleAllCheck = () => {
        let data = [];
        props.data.map((item) => {
            data.push(item.userID);
        });
        if (allCheck === false) {
            setAllCheck(true)
            setselected(data)
            props.checkUsers(data)
        } else {
            setAllCheck(false)
            setselected([])
        }
    }
    return (
        <>
            <Box sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'left',
                alignItems: 'left',
                padding: '3px'
            }}>
                <Checkbox
                    edge="start"
                    checked={allCheck}
                    onChange={handleAllCheck}
                    disableRipple
                    sx={{ '& .MuiSvgIcon-root': { fontSize: 20 } }}
                />
                <TextField
                    size="small"
                    fullWidth={true}
                    placeholder="Search Individuals or Groups"
                    InputProps={{
                        style: {
                            padding: 0
                        },
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon />
                            </InputAdornment>
                        ),
                    }}
                    sx={{ padding: 0, width:'75%' }}
                    value={props.search === "" ? props.search : search}
                    onChange={(event) => setSearchValue(event.target.value)}
                />
                <FormControl fullWidth={false} size="small" sx={{ paddingLeft: 1, width:'22%' }}>
                    <InputLabel id="order-by-select-label">
                        Order By
                    </InputLabel>
                    <Select
                        labelId="order-by-select-label"
                        id="order-by-select"
                        value={props.sortOrder}
                        label="Order By"
                        onChange={(event) =>
                            props.sortParticipants(
                                event.target.value
                            )
                        }>
                        <MenuItem key={1} value={'user'}>
                            User
                        </MenuItem>
                        <MenuItem key={2} value={"createdDate"}>
                            Created Date
                        </MenuItem>
                    </Select>
                </FormControl>
            </Box>
            <ParticipantPopUpWindowDataList
                data={props.data}
                onCheckSelect={onCheckSelect}
                handleToggle={handleToggle}
            />
        </>

    );
};

export default React.memo(ParticipantUserCheckList);
